//==============================
// Home Hero Slider
//==============================

var heroContentSlider = $('.home-hero .hero-content-slider');
var heroMediaSlider = $('.home-hero .hero-media-slider');

heroMediaSlider.on('init', function(event, slick, direction) {
  $('.home-hero').removeClass('init');
});

heroContentSlider.slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 1000,
  autoplaySpeed: 5000,
  autoplay: true,
  slidesToShow: 1,
  draggable: false,
  asNavFor: '.home-hero .hero-media-slider',
  touchThreshold: 10,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        speed: 600,
        vertical: false
      }
    }
  ]
});

heroMediaSlider.slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  draggable: false,
  asNavFor: '.home-hero .hero-content-slider',
  touchThreshold: 10,
  // centerMode: true,
  // centerPadding: '0',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        speed: 600,
        vertical: false
      }
    }
  ]
});
